import { Icon } from "@dmm-com/rocket-web-ui-library";
import { useMemo } from "react";
import * as Styles from "./style";
import { MyMenuItem } from "~/components/blocks/layout/global-navi/mobile/bottom-navi/my-menu-item";
import { VideoMenuItem } from "~/components/blocks/layout/global-navi/mobile/bottom-navi/video-menu-item";
import { EXTERNAL_PATHS } from "~/const/paths";
import { useWelcomePageUrl } from "~/hooks/use-welcome-page-url";
import { G_ServicePlan } from "~/lib/graphql";
import { sendTrackingClickCommon } from "~/lib/tracking/events";
import { useAuth } from "~/provider/auth";

export const BottomNavi = () => {
  const welcomePageUrl = useWelcomePageUrl();
  const { isLoggedIn, servicePlan } = useAuth();
  // memo: (okita) 無料プレミアム体験を表示する条件: 未ログイン時 || サービスプランがFREE
  const isDisplayPremium = useMemo(() => {
    return servicePlan === undefined || !isLoggedIn || servicePlan === G_ServicePlan.Free;
  }, [servicePlan, isLoggedIn]);

  return (
    <Styles.DivContainer>
      <Styles.ULWrapper>
        <VideoMenuItem />
        <MyMenuItem />
        {isDisplayPremium ? (
          <Styles.LIList>
            <Styles.AnchorItem href={welcomePageUrl}>
              <Icon name="premiumDmm" size="XL" />
              プレミアム
            </Styles.AnchorItem>
          </Styles.LIList>
        ) : (
          <Styles.LIList>
            <Styles.AnchorItem
              href={EXTERNAL_PATHS.BENEFIT}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                sendTrackingClickCommon({
                  clickEventName: "dmmtv_premiumsite_sp",
                  viaInfo: "footer_button",
                });
              }}
            >
              <Icon name="premiumDmm" size="XL" />
              プレミアム
            </Styles.AnchorItem>
          </Styles.LIList>
        )}
      </Styles.ULWrapper>
    </Styles.DivContainer>
  );
};
